import {useState} from 'react';
import {TwoFactorChallengePage} from '@common/auth/ui/two-factor/two-factor-challenge-page';
import {LoginPage} from '@common/auth/ui/login-page';
import {ResolvedCustomAuthPage} from '@app/custom-auth-pages/custom-auth-page';

interface Props {
  customAuthPage?: ResolvedCustomAuthPage;
}

export function LoginPageWrapper({customAuthPage}: Props = {}) {
  const [isTwoFactor, setIsTwoFactor] = useState(false);
  if (isTwoFactor) {
    return <TwoFactorChallengePage />;
  } else {
    return (
      <LoginPage
        customAuthPage={customAuthPage}
        onTwoFactorChallenge={() => setIsTwoFactor(true)}
      />
    );
  }
}
